export const JiraWorkManagementMarkBrand = () => (
	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M27.852 9.79885L22.156 32.2829C29.408 34.3319 35.191 31.6679 37.407 22.9199L40.731 9.79785H27.852V9.79885Z"
			fill="url(#paint0_linear_818_510)"
		/>
		<path
			d="M20.148 40.2007L25.844 17.7167C18.592 15.6677 12.809 18.3317 10.593 27.0797L7.26904 40.2017H20.148V40.2007Z"
			fill="#1D7AFC"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_818_510"
				x1="20.469"
				y1="32.3659"
				x2="32.167"
				y2="18.3079"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0055CC" />
				<stop offset="1" stopColor="#1D7AFC" />
			</linearGradient>
		</defs>
	</svg>
);
